import React from 'react';
import '../styles/theme.css';
import '../styles/Results.css';
import BruteHeader from '../components/BruteHeader';
import BruteFooter from '../components/BruteFooter';
import ResultsMasthead from '../components/ResultsMasthead';
import ResultsFindingsWall from '../components/ResultsFindingsWall';
import ResultsExportControls from '../components/ResultsExportControls';
/* IMPORTS */

function ResultsPage() {
  return (
    <div className="re-root">
      <div className="re-layout-1">
        <div id="resultsheaderslot" className="re-slot-resultsheaderslot">
          <BruteHeader activePage={"Results"} />
        </div>
        <div className="re-layout-2">
          <div id="resultsmasthead" className="re-slot-resultsmasthead">
            <ResultsMasthead />
          </div>
          <div id="resultsfindingswall" className="re-slot-resultsfindingswall">
            <ResultsFindingsWall />
          </div>
          <div id="resultsexportcontrols" className="re-slot-resultsexportcontrols">
            <ResultsExportControls />
          </div>
        </div>
        <div id="resultsfooterslot" className="re-slot-resultsfooterslot">
          <BruteFooter />
        </div>
      </div>
    </div>
  );
}

export default ResultsPage;